import DotsIcon from './component'

export default DotsIcon
